import { useState } from 'react';
import styles from './FAQAccordion.module.css';

const faqData = [
    {
        id: 1,
        question: "What is Neoo Search?",
        answer: "Neoo Search is a business directory and networking platform that helps users discover local businesses, explore services, and connect directly with verified businesses across cities and countries."
    },
    {
        id: 2,
        question: "How is Neoo Search different from other business directories?",
        answer: `<div><p>Neoo Search goes beyond basic listings. Unlike traditional directories that only display contact details, Neoo Search focuses on visibility, engagement, and business growth.</p>
        <p>Key differences include:</p>
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Free long-term business listings (not short trial periods).</li>
            <li>SEO-friendly business pages designed to appear in search results</li>
            <li>Analytics to track views, enquiries, and engagement</li>
            <li>Free NeooCard digital business cards</li>
            <li>Business networking and professional connections</li>
            <li>Direct customer enquiries via call, WhatsApp, and forms</li>
        </ul></div>`
    },
    {
        id: 3,
        question: "Why NeooCard?",
        answer: `<div><p>NeooCard is a smart, free digital business card that helps you connect faster, work smarter, and stay eco-friendly. It replaces traditional paper cards with a modern, shareable digital solution.</p>
         <p>Key benefits:</p> 
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Instant sharing via link or QR code</li>
            <li>Easy sharing on WhatsApp, email, and social media</li>
            <li>Eco-friendly and paperless</li>
            <li>Professional networking</li>
            <li>Digital contact management</li>
            <li>Always up-to-date information</li>
        </ul>
        </div>`
    },
    {
        id: 4,
        question: " Is NeooCard free or paid?",
        answer: `<div><p>NeooCard offers a free basic plan. Premium plans are available with advanced features for businesses that need more visibility and tools.</p></div>`
    },
    {
        id: 5,
        question: "What features are included in the Basic NeooCard?",
        answer: `<div>
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Business address</li>
            <li>QR code with profile link</li>
            <li>Social media links</li>
            <li>Contact directory</li>
            <li>Easy sharing and connecting</li>
            <li>Basic analytics</li>
        </ul>
        </div>`
    },
    {
        id: 6,
        question: "What features are included in the Premium NeooCard?",
        answer: `<div>
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Business address</li>
            <li>QR code with profile link</li>
            <li>Products and services listing</li>
            <li>Video and PDF profile</li>
            <li>Social media links</li>
            <li>Contact directory</li>
            <li>Private chat</li>
            <li>Advanced analytics</li>
            <li>NFC digital business card</li>
        </ul>
        </div>`
    },
    {
        id: 7,
        question: "What is the price of the Premium NeooCard?",
        answer: `<div><p>Premium NeooCard plans start from <strong>100 AED per user</strong>, depending on the selected package. For full details, visit the Price & Plans page:</p>
        <p>https://www.neoosearch.com/business-directory-listing-pricing</p>
        </div>`
    },
    {
        id: 8,
        question: "What is the validity of the Premium NeooCard?",
        answer: `<div><p>Premium NeooCard comes with <strong>lifetime validity</strong>.</p></div>`
    },
    {
        id: 9,
        question: "Who can use NeooCard?",
        answer: `<div><p>NeooCard is designed for individuals aged 18 and above, including business owners, professionals, freelancers, and entrepreneurs.</p></div>`
    },
    {
        id: 10,
        question: "What is the Neoo Search Business Directory?",
        answer: `<div><p>The Neoo Search Business Directory is a searchable platform where users can find verified businesses by category and location, view details, and connect easily.</p></div>`
    },
    {
        id: 11,
        question: "How can I find a business on Neoo Search?",
        answer: `<div>
         <p>You can search using:</p> 
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Business name</li>
            <li>Person name</li>
            <li>Category</li>
            <li>Keywords</li>
            <li>Location or city</li>
        </ul>
        </div>`
    },
    {
        id: 12,
        question: "Can I list my business in the Neoo Search Business Directory?",
        answer: `<div><p>Yes. <strong>Only registered businesses</strong> can be listed. To add your business, visit the Price & Plans page, choose a plan, and submit your business details for review. Once approved, your business will appear in the directory.</p>
        <p>https://www.neoosearch.com/business-directory-listing-pricing</p></div>`
    },
    {
        id: 13,
        question: "Is business listing free on Neoo Search?",
        answer: `<div>
         <p>Yes. Neoo Search offers free long-term listing plans:</p> 
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li><strong>Basic Plan:</strong> Free for 2 years</li>
            <li><strong>Silver Plan:</strong> Free for 3 years</li>
            <li><strong>Gold Plan:</strong> Free for 4 years</li>
        </ul>
        <p>Each plan includes essential listing features, with additional benefits based on the selected plan.</p>
        </div>`
    },
    {
        id: 14,
        question: "How accurate and reliable are the business listings?",
        answer: `<div><p>Neoo Search maintains high-quality listings. Businesses can update their information, and users can view verified details and reviews (if available).</p></div>`
    },
    {
        id: 15,
        question: "How can I promote my business page on Neoo Search?",
        answer: `<div>
        <p>You can promote your business by:</p> 
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Posting updates about products, services, or offers</li>
            <li>Targeting the right audience</li>
            <li>Receiving direct enquiries</li>
            <li>Tracking performance through analytics</li>
        </ul>
        </div>`
    },
    {
        id: 16,
        question: "Are Neoo Search business pages SEO-friendly?",
        answer: `<div><p>Yes. All business pages are SEO-optimized with clean URLs, internal linking, mobile-friendly design, and fast loading speed to improve visibility.</p></div>`
    },
    {
        id: 17,
        question: " Is Neoo Search available in multiple countries?",
        answer: `<div><p>Yes. Neoo Search currently supports India, UAE, and GCC countries, with plans for global expansion.</p></div>`
    },
    {
        id: 18,
        question: "What are Neoo Search Reward Points?",
        answer: `<div>
        <p>Neoo Search Reward Points are loyalty points earned by Premium NeooCard members for engaging on the platform.</p> 
        <p>Welcome Points by Card Type:</p>
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Silver NeooCard: 1,500 points</li>
            <li>Gold NeooCard: 3,000 points</li>
            <li>Platinum NeooCard: 5,000 points</li>
        </ul>
        </div>`
    },
    {
        id: 19,
        question: "Who is eligible to earn Neoo Search Reward Points?",
        answer: `<div><p>Only Premium NeooCard members are eligible to earn Reward Points.</p></div>`
    },
    {
        id: 20,
        question: "How can Premium members earn Reward Points?",
        answer: `<div>
        <p>Points are earned through activities such as:</p> 
        <ul style="list-style-type: disc; margin-left: 50px;">
            <li>Adding NeooCard members</li>
            <li>Profile engagement (likes, calls, WhatsApp, visits)</li>
            <li>Social media and website clicks</li>
            <li>Product views, videos, downloads, and ratings</li>
            <li>Referrals and offer redemptions</li>
        </ul>
        </div>`
    },
    {
        id: 21,
        question: "What are Neoo Search Reward Points used for?",
        answer: `<div><p>Reward Points can be used to create and redeem offer vouchers through the Reward Dashboard. These offers can be redeemed at Neoo Search partner stores. Each redemption also earns bonus points, maximizing value while helping grow your business.</p></div>`
    },
    {
        id: 22,
        question: "Are Neoo Search QR codes free, and do they expire?",
        answer: `<div><p>Yes. QR codes generated with Neoo Search are completely free, static, and come with lifetime validity. They do not expire and allow unlimited scans through your NeooCard profile.</p><p>Since they are static QR codes, the profile name cannot be changed after the QR code has been generated.</p></div>`
    },
];

const FAQAccordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className={styles.container}>
            <h2 className={styles.title}>Frequently Asked Questions</h2>
            <p className={styles.subtitle}>
                Can't find what you're looking for? Reach out to our support team.
            </p>

            <div className={styles.accordionWrapper}>
                {faqData.map((item, index) => {
                    const isOpen = activeIndex === index;

                    return (
                        <div key={item.id} className={styles.item}>
                            {/* The clickable header */}
                            <button
                                className={`${styles.questionTrigger} ${isOpen ? styles.active : ''}`}
                                onClick={() => handleToggle(index)}
                                aria-expanded={isOpen}
                                aria-controls={`answer-${item.id}`}
                            >
                                <span className={styles.questionText}>{item.question}</span>
                                {/* Pure CSS Chevron Icon */}
                                <div className={styles.iconWrapper}>
                                    <div className={styles.chevron}></div>
                                </div>
                            </button>

                            {/* The answer body wrapper with smooth transition */}
                            <div
                                id={`answer-${item.id}`}
                                className={`${styles.answerGridWrapper} ${isOpen ? styles.open : ''}`}
                                role="region"
                            >
                                <div className={styles.answerOverflow}>
                                    <div
                                        className={styles.answerBody}
                                        dangerouslySetInnerHTML={{ __html: item.answer }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default FAQAccordion;